// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5435": "c62902b5","8383": "81850193","8448": "8f0b63be","8457": "790bc4bf",}[chunkId] + ".css"
}